import { keyframes, css } from '@emotion/react'
import { Color, GemColors, Spacing, Theme, wideGamutColor } from '@opallabs/gem'

const shimmer = keyframes({
  '0%': {
    backgroundPosition: '-1000px 0',
  },
  '100%': {
    backgroundPosition: '1000px 0',
  },
})

export const row = (
  size: 'short' | 'tall',
  percentWidth: number,
  theme: Theme
) =>
  css({
    // Shimmer effect
    animation: `${shimmer} 2s infinite linear`,
    background: `linear-gradient(to right, 
      ${wideGamutColor(GemColors.N100)} 10%, 
      ${Color[theme]['Color/Surface/Surface-3']} 25%, 
      ${wideGamutColor(GemColors.N100)} 50%)`,
    backgroundSize: '1000px 100%',
    // Row structure
    borderRadius: Spacing.XS,
    blockSize: size === 'short' ? 12 : 24,
    marginBlockEnd: size === 'short' ? Spacing.M - Spacing.XS : Spacing.L,
    inlineSize: `${percentWidth}%`,
  })

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  blockSize: '100%',
  padding: Spacing.M,
  minInlineSize: 680,
})
